import React from 'react';
import {Button} from "@material-ui/core";

export default function WuButton(props) {
    return (
        <Button  disableElevation color={'primary'} variant={'contained'} {...props}/>
    )
}